import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import authFetch from '../../utils/authFetch';
import './Library.css';

const Library = () => {
  const [ents, setEnts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [role, setRole] = useState({ isAdmin: false, isPublisher: false, status: null });

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await authFetch('/api/store/library');
        if (!res.ok) throw new Error('Failed to load library');
        const json = await res.json();
        setEnts(json?.entitlements || []);
      } catch (e) {
        setError(e.message || 'Failed to load library');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  useEffect(() => {
    const loadRole = async () => {
      try {
        const res = await authFetch('/api/store/publisher/me/role');
        const json = await res.json();
        if (json) setRole(json);
      } catch {}
    };
    loadRole();
  }, []);

  const onDownload = async (productId, formatId) => {
    try {
      const res = await authFetch('/api/store/downloads/sign', { method: 'POST', body: { productId, formatId } });
      const json = await res.json();
      if (json?.url) {
        window.location.href = json.url;
      } else {
        alert('Unable to get download link');
      }
    } catch (e) {
      alert('Download failed');
    }
  };

  return (
    <div className="ebookstore-library">
      <div className="books-header" style={{marginBottom: '6px'}}>
        <h1>My Library</h1>
        <div className="header-ctas">
          {role.isAdmin && (
            <Link className="btn-header" to="/eBookstore/admin/submissions">Admin Submissions</Link>
          )}
          {role.isPublisher ? (
            <Link className="btn-header" to="/eBookstore/publisher/dashboard">Publisher Dashboard</Link>
          ) : (
            <Link className="btn-header accent" to="/eBookstore/publisher/onboarding">Become a Publisher</Link>
          )}
        </div>
      </div>
      {loading && <div className="loading">Loading...</div>}
      {error && <div className="error">{error}</div>}
      {!loading && !error && ents.length === 0 && (
        <div className="empty">
          <p>No purchases yet.</p>
          <a className="btn-cta" href="/eBookstore">Browse the catalog →</a>
        </div>
      )}
      <div className="library-grid">
        {ents.map(e => (
          <div key={e.id} className="library-card">
            <div className="cover"><img src={e.product?.cover_url || ''} alt={e.product?.title || 'Book'} /></div>
            <div className="info">
              <h3>{e.product?.title || 'Untitled'}</h3>
              <div className="formats">
                {(e.product?.formats || []).map(f => (
                  <button key={f.id} className="btn-format" onClick={() => onDownload(e.product.id, f.id)}>
                    Download {String(f.type).toUpperCase()}
                  </button>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Library;
